import { useEffect } from "react";
import { initListeners } from "./store";
import { Unsubscribe } from "@reduxjs/toolkit";
import theme from "./theme";
import Bootstrap from "./Bootstrap";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Wizard from "features/wizard";
import Confirmation from "features/confirmation";
import Reset from "features/user/Reset";
import Buy from "features/buy";
import { Dashboard } from "features/dashboard";

function App() {
  useEffect(() => {
    const subscriptions: Unsubscribe[] = initListeners();
    return () => subscriptions.forEach((unsubscribe) => unsubscribe());
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
        <Router basename={process.env.PUBLIC_URL}>
          <Switch>
            <Bootstrap>
              <Switch>
                <Route exact path="/session/:id" component={Confirmation} />
                <Route exact path="/reset/:token" component={Reset} />
                <Route exact path="/buy" component={Buy} />
                <Route exact path="/" component={Wizard} />
                <Route
                  exact
                  path="/dashboard/:section?/:subSection?"
                  component={Dashboard}
                />
              </Switch>
            </Bootstrap>
          </Switch>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
